import { useMemo } from 'react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchNavigation } from '../../api/portalGateway/navigation';
import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { useStore } from '../../store';
import { prependRoleId } from '../../utils/prependRoleId';
import { pageWithRoleLink } from '../../utils/urlPath';

const navigation = () => {
  return queryOptions({
    queryKey: prependRoleId(['navigation']),
    queryFn: fetchNavigation,
  });
};

export const useGetStaticNavData = () => {
  const roleId = useStore((state) => state.activeUserRole?.id);
  const { data, isPending } = useQuery(navigation());

  return useMemo(() => {
    if (!data?.data.rootNavigationItems) {
      return { initialPageSlug: null, navItems: [], isPending };
    }

    const navItems = data.data.rootNavigationItems.map((item) => ({
      href: pageWithRoleLink(roleId ?? NO_ROLE_ID, {
        slug:
          item.type === 'navigation-menu-item'
            ? item.pageSlug
            : item.completeSlug,
      }),
      iconName: item.icon ?? 'draft',
      label: item.label,
      completeSlug: item.slug,
    }));

    return {
      initialPageSlug: data.data.initialPageSlug,
      navItems: navItems,
      isPending,
    };
  }, [data, roleId, isPending]);
};
